<template>
  <article class="content row align-center">
    <div class="large-11 columns">
      <section class="form-section">
        <h1 class="form-section__title">
          {{ $t('ACCOUNT.PUBLISHER_INFO_TITLE') }}
        </h1>

        <div class="row align-justify">
          <div class="small-12 large-4 columns">
            <p class="form-section__description">
              {{ $t('ACCOUNT.PUBLISHER_INFO_DESC') }}
            </p>
          </div>

          <div class="small-12 large-7 columns">
            <div class="card">
              <div class="card__block">
                <dl class="list list--definition list--clean">
                  <dt>{{ $t('ACCOUNT.PUBLISHER_NAME') }}</dt>
                  <dd>{{ publisher.name }}</dd>

                  <dt>{{ $t('ACCOUNT.PUBLISHER_EMAIL') }}</dt>
                  <dd>{{ publisher.email }}</dd>
                </dl>
              </div>

              <div class="card__block">
                <ElButton
                  :plain="true"
                  :disabled="publisher.verification_state == 'B'"
                  type="danger"
                  @click="resignWithConfirm"
                >
                  {{ $t('ACCOUNT.RESIGN') }}
                </ElButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </article>
</template>

<script>
import { Agents } from '@/api/api';

import layout from '@/mixins/layout';

export default {
  name: 'Account',

  mixins: [layout],

  computed: {
    agent() {
      return this.$auth.user;
    },

    publisher() {
      const { publisher = {} } = this.agent;

      return publisher;
    },
  },

  created() {
    // set the page title
    this.setPageTitle('SETTINGS');
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      // @TODO prevent publisher accounts from seeing this page temporarily
      if (vm.$auth.check('publisher')) {
        let addr = '/';

        if (to.redirectedFrom === '/settings/') {
          addr = { name: 'account-status' };
        }

        vm.$router.push(addr);
      }
    });
  },

  methods: {
    resignWithConfirm() {
      return this.$confirm(
        this.$t('ACCOUNT.RESIGN_AGENT_CONFIRM_MSG'),
        this.$t('WARNING'),
        {
          confirmButtonText: this.$t('ACCOUNT.RESIGN_AGENT_CONFIRM_BTN'),
          cancelButtonText: this.$t('CANCEL'),
          cancelButtonClass: 'el-button--text is-plain',
          type: 'warning',
        },
      )
        .then(() => {
          this.resignAgent();
        })
        .catch(() => {});
    },

    resignAgent() {
      return Agents.resign({ id: this.agent.id })
        .then(() => {
          this.$router.replace({ name: 'logout' });
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
  },
};
</script>
